/**
 * ArticlePage - Página principal de listagem de todos os artigos
 *
 * TRANSFORMER PATTERN:
 * Esta página agora usa ArticleListPageTemplate com configuração padrão.
 * - baseFilter: {} (sem filtro = todos os artigos)
 * - pageTitle: "Artigos"
 * - pageConfig: { showScraping: true, showBackgroundScraping: true }
 *
 * ANTES: 1243 linhas de código
 * DEPOIS: 10 linhas de código
 * REDUÇÃO: 99% menos código!
 */
import React from 'react';
import ArticleListPageTemplate from '../components/templates/ArticleListPageTemplate/ArticleListPageTemplate';

const ArticlePage = () => {
  return (
    <ArticleListPageTemplate
      pageTitle="Artigos"
      baseFilter={{}}
      pageConfig={{
        showScraping: true,
        showBackgroundScraping: true
      }}
    />
  );
};

export default ArticlePage;
